// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ResponseHandler$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";
import * as ServiceabilityStateMapper from "../entity-mapper/ServiceabilityStateMapper.bs.js";

var execute = ServiceabilityStateMapper.decodeHelperServiceabilityInfo;

var HelperServiceabilityResponseConverterConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var HelperServiceabilityResponseConverter = partial_arg(HelperServiceabilityResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$1 = ServiceabilityStateMapper.decodeOutStationServiceabilityInfo;

var OutStationServiceabilityResponseConverterConfig = {
  execute: execute$1
};

var partial_arg$1 = ResponseHandler$Catalyst.ResponseConverter;

var OutStationServiceabilityResponseConverter = partial_arg$1(OutStationServiceabilityResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$2 = ServiceabilityStateMapper.decodeRentalServiceabilityInfo;

var RentalServiceabilityResponseConverterConfig = {
  execute: execute$2
};

var partial_arg$2 = ResponseHandler$Catalyst.ResponseConverter;

var RentalServiceabilityResponseConverter = partial_arg$2(OutStationServiceabilityResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$3 = ServiceabilityStateMapper.decodeHelperServiceabilityInfo;

var HelperLabourServiceabilityResponseConverterConfig = {
  execute: execute$3
};

var partial_arg$3 = ResponseHandler$Catalyst.ResponseConverter;

var HelperLabourServiceabilityResponseConverter = partial_arg$3(HelperLabourServiceabilityResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  HelperServiceabilityResponseConverterConfig ,
  HelperServiceabilityResponseConverter ,
  OutStationServiceabilityResponseConverterConfig ,
  OutStationServiceabilityResponseConverter ,
  RentalServiceabilityResponseConverterConfig ,
  RentalServiceabilityResponseConverter ,
  HelperLabourServiceabilityResponseConverterConfig ,
  HelperLabourServiceabilityResponseConverter ,
  
}
/* HelperServiceabilityResponseConverter Not a pure module */
